import { Box } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { Dayjs } from 'dayjs';
import DropdownMenuButton from '@components/buttons/DropdownMenuButton';
import ClearanceDateTimePicker from './ClearanceDateTimePicker';

type ExportItem = {
  label: string;
  onClick: () => void;
};

type ActivityHeaderControlsProps = {
  startDt: Dayjs | null;
  endDt: Dayjs | null;
  onStartDtChange: (value: Dayjs | null) => void;
  onEndDtChange: (value: Dayjs | null) => void;
  exportItems: ExportItem[];
};

// The date range and export menu above an activity log grid. The start can't
// be moved past the end, or the end before the start.
const ActivityHeaderControls = ({
  startDt,
  endDt,
  onStartDtChange,
  onEndDtChange,
  exportItems
}: ActivityHeaderControlsProps) => (
  <Box sx={{ mt: 3, mb: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
    <Box />
    <Box>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <ClearanceDateTimePicker
          label='Start date & time'
          value={startDt}
          maxDateTime={endDt ?? undefined}
          onChange={(newValue) => {
            if (endDt !== null && newValue !== null && newValue.isAfter(endDt)) {
              onStartDtChange(endDt);
            } else {
              onStartDtChange(newValue);
            }
          }}
        />
        <ClearanceDateTimePicker
          label='End date & time'
          value={endDt}
          minDateTime={startDt ?? undefined}
          ml='16px'
          onChange={(newValue) => {
            if (startDt !== null && newValue !== null && newValue.isBefore(startDt)) {
              onEndDtChange(startDt);
            } else {
              onEndDtChange(newValue);
            }
          }}
        />
        <Box sx={{
          height: '40px',
          display: 'inline-block',
          alignContent: 'center',
          ml: '16px'
        }}>
          <DropdownMenuButton label='Export' items={exportItems} />
        </Box>
      </LocalizationProvider>
    </Box>
  </Box>
);

export default ActivityHeaderControls;
